import { computed, defineComponent } from "@vue/composition-api";
import PageSectionGroupLayout from "@Client/@Modules/application-standalone/components/layout/page-section-group-layout.vue";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import TextareaField from "@Shared/components/form-elements/fields/textarea-field.vue";
import { useApplicationStandaloneStoreGetters, useApplicationStandaloneStoreMutations } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import * as ApplicationStandAloneMutations from "@Client/@Modules/application-standalone/store/application-standalone-mutations";
export default defineComponent({
  name: "AdditionalInformationSection",
  components: {
    PageSectionGroupLayout,
    SectionTitle,
    TextareaField
  },
  setup() {
    const {
      GET_ADDITIONAL_INFORMATION
    } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_ADDITIONAL_INFORMATION]);
    const {
      SET_ADDITIONAL_INFORMATION
    } = useApplicationStandaloneStoreMutations([ApplicationStandAloneMutations.SET_ADDITIONAL_INFORMATION]);
    const additionalInformation = computed({
      get() {
        return GET_ADDITIONAL_INFORMATION;
      },
      set(value) {
        return SET_ADDITIONAL_INFORMATION(value);
      }
    });
    return {
      additionalInformation
    };
  }
});